<template>
  <div v-if="visible" class="lab-mask" @pointerdown.self.prevent>
    <section ref="dialog" class="lab-modal" :class="size" role="dialog" aria-modal="true" :aria-label="title" tabindex="-1" @keydown.esc.stop>
      <header class="lab-modal-h"><h4>{{ title }}</h4><button type="button" class="lab-close" aria-label="关闭弹窗" @click="$emit('close')">×</button></header>
      <div class="lab-modal-b"><slot /></div>
      <footer class="lab-modal-f"><slot name="footer"><button type="button" class="btn" @click="$emit('close')">关闭</button></slot></footer>
    </section>
  </div>
</template>
<script>
export default {
  name: 'NetworkLabDialog', props: { visible: Boolean, title: String, size: { type: String, default: '' } },
  watch: { visible (value) { if (value) this.$nextTick(() => { if (this.$refs.dialog) this.$refs.dialog.focus() }) } }
}
</script>
